<template>
  <vc-donut
    background="white" 
    foreground="grey"
    :size="200" unit="px" :thickness="20"
    :sections="sections" :total="100"
  >
  <div class="donut-label">{{$t("graph.report_lamp_fail")}}</div>
  <div class="donut-value">{{this.totalLampError}}</div>
  </vc-donut>
</template>

<script>
import Vue from 'vue';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
Vue.use(Donut);

  export default {
    name: 'GraficoDonutReportError',
    props: {
      graphData: Array
    },
    mounted(){
      
      console.log("GRAPHDATA: ", this.graphData);
        //this.totalError=this.graphData[0];
        var totalError = this.graphData.slice(1).reduce( (acc, val) => acc + val);
        var numHwError=this.graphData[1];
        var numLedError=this.graphData[2];
        var numBattShort=this.graphData[3];
        var numBattFunctError=this.graphData[4];
        var numBattAutoError=this.graphData[5];
        var numComError=this.graphData[6];
        var numUvoxyError=this.graphData[7];
        var numUnderpowerError=this.graphData[8];
        var numUndervoltageError=this.graphData[9];
        var numOverpowerError=this.graphData[10];
        var numOvervoltageError=this.graphData[11];
        var numCommRadioLampError=this.graphData[12];
        var numOrphan=this.graphData[13];

        var numDaliError = this.graphData[14];
        var numUnderThresholdError = this.graphData[15];
        var numProgError = this.graphData[16];
        var numBusVoltError = this.graphData[17];
        var numDuplicateError = this.graphData[18];
        var numLineFuse = this.graphData[19];
        
        //this.totalError=this.totalError+numUvoxyError;
        this.totalLampError = this.graphData[0] + numUvoxyError;
        
        console.log("DONUT ERROR: ", totalError, this.totalLampError);

        
        this.sections=[];
        var numHwError_p={value:(numHwError/totalError)*100, color:"#8f2710"};     //marrone
        var numLedError_p={value:(numLedError/totalError)*100, color:"#8f5a10"};   //senape
        var numBattShort_p={value:(numBattShort/totalError)*100, color:"#8f105f"};  //viola
        var numBattFunctError_p={value:(numBattFunctError/totalError)*100, color:"#db1f18"}; //rosso
        var numBattAutoError_p={value:(numBattAutoError/totalError)*100, color:"#db6d18"};   //arancione
        var numComError_p={value:(numComError/totalError)*100, color:"#efb954"}; //giallo
        var numUvoxyError_p={value:(numUvoxyError/totalError)*100, color:"#3287a8"}; //blu
        var numUnderpowerError_p={value:(numUnderpowerError/totalError)*100, color:"#6d597a"}; //violetto
        var numUndervoltageError_p={value:(numUndervoltageError/totalError)*100, color:"#b56576"};   //rosa scuro  
        var numOverpowerError_p={value:(numOverpowerError/totalError)*100, color:"#723d46"};  //marrone
        var numOvervoltageError_p={value:(numOvervoltageError/totalError)*100, color:"#472d30"};   //marrone scuro
        var numCommRadioLampError_p={value:(numCommRadioLampError/totalError)*100, color:"#000814"};   //nero
        var numOrphan_p={value:(numOrphan/totalError)*100, color:"#EE82EE"};   //viola
        var no_Error_p={value:100, color:"#29CC96"};  //verde

        //SICURO
        var numDaliError_p = {value:(numDaliError/totalError)*100, color:"#FFFF33"};   //bright lemon
        var numUnderThresholdError_p = {value:(numUnderThresholdError/totalError)*100, color:"#FFD700"}; //warm gold
        var numProgError_p = {value:(numProgError/totalError)*100, color:"#FFDB58"}; //mustard
        var numBusVoltError_p = {value:(numBusVoltError/totalError)*100, color:"#FFFFCC"}; //pale cream
        var numDuplicateError_p = {value:(numDuplicateError/totalError)*100, color:"#DFFF00"}; //chartreuse
        var numLineFuse_p = {value:(numLineFuse/totalError)*100, color:"#B4C424"}; //muted peridot


        if(this.totalLampError>0)
        {
          this.sections.push(numHwError_p);
          this.sections.push(numLedError_p);
          this.sections.push(numBattShort_p);
          this.sections.push(numBattFunctError_p);
          this.sections.push(numBattAutoError_p);
          this.sections.push(numComError_p);
          this.sections.push(numUvoxyError_p);
          this.sections.push(numUnderpowerError_p);
          this.sections.push(numUndervoltageError_p);
          this.sections.push(numOverpowerError_p);
          this.sections.push(numOvervoltageError_p);
          this.sections.push(numCommRadioLampError_p);
          this.sections.push(numOrphan_p);

          this.sections.push(numDaliError_p);
          this.sections.push(numUnderThresholdError_p);
          this.sections.push(numProgError_p);
          this.sections.push(numBusVoltError_p);
          this.sections.push(numDuplicateError_p);
          this.sections.push(numLineFuse_p);
        }
        else
        {
          this.sections.push(no_Error_p);
        }

        console.log("error type section: ",this.sections);
    },

    data() {
      return {
          sections: [],
          totalLampError:0
      };
    }
  };
</script>
